import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  > div:nth-child(3) {
    margin-right: 12px;
  }
  > div:nth-child(2) {
    margin-right: 6px;
  }
  > div {
    margin-right: 16px;
  }
`;

export const FieldWrapper = styled.div<{ flex?: number }>`
  flex: ${(props) => props.flex || 1};
  gap: 5px;
`;
